module.exports = __webpack_public_path__ + "static/media/listEmbracon.de9b5f06.jpg";